

// var urlString = process.env.REACT_APP_API_URL_PROD
var urlString = process.env.REACT_APP_API_URL 
// var urlString = "http://localhost:8081/"
// var urlString = "http://192.168.1.173:8081/"
// var urlString = "http://192.168.1.9:8081/"


const PostApiCall = {
  postRequest(userData, url) {
        
const getToken=localStorage.getItem("authToken")

    return fetch(urlString + url, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': '*',
        'Access-Control-Allow-Methods': '*',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${getToken}`,
      },
      credentials: "include",
      body: JSON.stringify(userData),

    })
      .then(response => {
        return (response)

      })
      .catch(error => {
       
        return error;
      });
  },
};

export default PostApiCall;
